import React, { useState, useEffect } from "react";
import { FiTrash2 } from "react-icons/fi";
import { FaSearch } from "react-icons/fa"; // Импортируем иконку поиска
import Header from '../../../components/Admin/Header';
import Sidebar from '../../../components/Admin/Sidebar';
import { Link } from 'react-router-dom';
import { $host } from "../../../http";
import UserModal from "./components/UserModal";

import "./UsersPage.css";


const UsersPage = () => {
  const [users, setUsers] = useState([]);
  const [isLoading, setIsLoading] = useState(true);
  const [searchTerm, setSearchTerm] = useState("");

  // Пагинация
  const [currentPage, setCurrentPage] = useState(1);
  const [limit] = useState(20); // Количество пользователей на странице
  const [totalPages, setTotalPages] = useState(1); // Общее количество страниц

  const [selectedUser, setSelectedUser] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleUserClick = (user) => {
    setSelectedUser(user);
    setIsModalOpen(true);
  };


  // Функция загрузки пользователей
  const fetchUsers = async (page = 1, search = "") => {
    setIsLoading(true);
    try {
      const { data } = await $host.get("/api/admin/users", {
        params: { page, limit, search },
      });

      console.log("Ответ API:", data);

      setUsers(data.users || []);
      setTotalPages(data.totalPages || 1);
    } catch (error) {
      console.error("Ошибка загрузки пользователей:", error);
    } finally {
      setIsLoading(false);
    }
  };


  // Обновляем список пользователей при изменении страницы или поиска
  useEffect(() => {
    const delayDebounceFn = setTimeout(() => {
      fetchUsers(currentPage, searchTerm);
    }, 500); // Дебаунс 500 мс

    return () => clearTimeout(delayDebounceFn);
  }, [currentPage, searchTerm]);

  // Удаление пользователя
  const handleDeleteUser = async (userId) => {
    try {
      await $host.delete(`/api/admin/users/${userId}`);

      setUsers(users.filter((user) => user.id.toString() !== userId.toString()));
    } catch (error) {
      console.error("Ошибка:", error);
    }
  };



  const handleRoleChange = async (userId, newRole) => {
    try {
      await $host.put(`/api/admin/users/${userId}`, { role: newRole });

      setUsers(users.map(user =>
        user.id.toString() === userId.toString() ? { ...user, role: newRole } : user
      ));
    } catch (error) {
      console.error("Ошибка:", error);
    }
  };


  const countRoles = () => {
    const rolesCount = {
      student: 0,
      teacher: 0,
      mentor: 0,
      // можно добавить другие роли
    };

    // Проверяем, что users - это массив перед использованием forEach
    if (Array.isArray(users)) {
      users.forEach(user => {
        if (user.role) {
          rolesCount[user.role] = (rolesCount[user.role] || 0) + 1;
        }
      });
    }

    return rolesCount;
  };

  const rolesCount = countRoles();

  useEffect(() => {
    fetchUsers();
  }, []);

  // Фильтрация пользователей по поисковому запросу
  const filteredUsers = users.filter(user =>
    (user.name && user.name.toLowerCase().includes(searchTerm.toLowerCase())) ||
    (user.id && user.id.toString().includes(searchTerm))
  );

  return (
    <div>
      <Header />
      <div className="users-container">
        <Sidebar />
        {isModalOpen && (
          <UserModal user={selectedUser} onClose={() => setIsModalOpen(false)} />
        )}

        <main className="users-content">
          <nav className="breadcrumbs">
            <Link to="/admin/users">Пользователи</Link>
            <span>/</span>
            <span>{`${rolesCount.student || 0} учеников`}</span>
            <span>/</span>
            <span>{`${rolesCount.teacher || 0} учителей`}</span>
            <span>/</span>
            <span>{`${rolesCount.curator || 0} наставников`}</span>
          </nav>

          <div className="search-container">
            <FaSearch className="search-icon" size={20} />
            <input
              type="text"
              placeholder="Введите имя, фамилию или ID пользователя"
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
              className="search-input"
            />
          </div>

          {isLoading ? (
            <div className="text-center">Загрузка...</div>
          ) : (
            <table className="users-table">
              <thead>
                <tr>
                  <th>№</th>
                  <th>Имя</th>
                  <th>Фамилия</th>
                  <th>Email</th>
                  <th>Роль</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {users.length > 0 ? (
                  users.map((user, index) => (
                    <tr key={user.id} onClick={() => handleUserClick(user)} className="user-row">
                      <td>{(currentPage - 1) * limit + index + 1}</td>
                      <td>{user.first_name || "Не указано"}</td>
                      <td>{user.last_name && user.last_name !== "<nil>" ? user.last_name : "Не указано"}</td>
                      <td>{user.email || "Нет Email"}</td>
                      <td>
                        <select
                          value={user.role}
                          onChange={(e) => handleRoleChange(user.id, e.target.value)}
                          onClick={(e) => e.stopPropagation()}
                        >
                          <option value="curator">Наставник</option>
                          <option value="teacher">Преподаватель</option>
                          <option value="student">Ученик</option>
                        </select>
                      </td>
                      <td>
                        <button onClick={(e) => { e.stopPropagation(); handleDeleteUser(user.id); }}>
                          <FiTrash2 />
                        </button>
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan={6}>Нет пользователей</td>
                  </tr>
                )}
              </tbody>

            </table>
          )}

          {/* Кнопки пагинации */}
          <div className="pagination">
            <button disabled={currentPage === 1} onClick={() => setCurrentPage(currentPage - 1)}>
              Назад
            </button>
            <span>Страница {currentPage} из {totalPages}</span>
            <button disabled={currentPage === totalPages} onClick={() => setCurrentPage(currentPage + 1)}>
              Вперёд
            </button>
          </div>

        </main>
      </div>

    </div>
  );
};

export default UsersPage;
